import axios from 'axios'

const logJs = {}
logJs.report = function (type) {
  axios.get('http://web.shankm.xyz/offcial/report', {
    params: {
      game: 'shankm',
      num: '995192594',
      sig: 'fa3e51df37ab908b08bfc1853ee4c289',
      type: type
    }
  })
    .then(function (response) {
    })
    .catch(function (error) {
    });
}

export default logJs;